import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=2d70f6c8&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=ts"
export * from "./SettingsNavigation.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNavigation.vue?vue&type=style&index=0&id=2d70f6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70f6c8",
  null
  
)

export default component.exports